export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  // Only load GTM when analytics is enabled and GTM ID is provided
  if (!config.public.analyticsEnabled || !config.public.gtmId) {
    return
  }

  // Skip GTM initialization during Cypress tests
  if (typeof window !== 'undefined' && window.Cypress) {
    return
  }

  const gtmId = config.public.gtmId

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || []

  // GTM script injection
  const script = document.createElement('script')
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `
  document.head.appendChild(script)

  // Add noscript fallback to body
  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.appendChild(noscript)
})

// Type declarations for TypeScript
declare global {
  interface Window {
    dataLayer: any[]
  }
}
